import { render, staticRenderFns } from "./ReporteControlVentasSuperUsuario.vue?vue&type=template&id=4b8ca833&scoped=true"
import script from "./ReporteControlVentasSuperUsuario.vue?vue&type=script&lang=js"
export * from "./ReporteControlVentasSuperUsuario.vue?vue&type=script&lang=js"
import style0 from "./ReporteControlVentasSuperUsuario.vue?vue&type=style&index=0&id=4b8ca833&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8ca833",
  null
  
)

export default component.exports